/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { css } from 'styled-components';
import Button from '@vfuk/core-button';

const externalLinkStyles = css`
  color: var(--white);
  background: var(--red);
  font-size: 20px;
  appearance: none;
  cursor: pointer;
  padding: 12px 37px;
  text-align: center;
  margin: 4px;

  &:hover {
    background: var(--crimsonRed);
  }
`;

const externalLinkWrapperStyles = css`
  padding: 10px 0;
  max-width: 40%;
`;

type ExternalLinkProps = {
  label: string;
  href: string;
  seoString: string;
};

const SeoCtaExternalLink = ({ label, href, seoString }: ExternalLinkProps) => {
  const onClickHandler = () => {
    let seoEventText = 'V-Hub:' + document.title + ':' + label + ':';
    const seoNo = seoString.slice(-1);
    if (seoNo !== '0') {
      seoEventText = seoEventText + seoNo + ':';
    }
    seoEventText = seoEventText + 'CTA';

    if(window.utag && window.utag.link && typeof window.utag.link === "function") {
      window.utag.link({
        link_name: seoEventText,
        tealium_event: 'link',
      });
    }
    window.open(href, '_blank');
  };

  return (
    <div css={externalLinkWrapperStyles}>
      <Button
        text={label}
        appearance="primary"
        onClick={onClickHandler}
      />
    </div>
  );
};

export default SeoCtaExternalLink;
